import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../authentication/AuthenticationContext';
import { GameConfig, GameProviderConfig } from '../../../Config.model';
import { useConfig } from '../../../ConfigContext';
import { GameIds } from '../../my-games/MyGames.model';
import { ProviderComponent } from './Provider';

interface Props {
  requiredGameId: GameIds;
  nextStep: () => void;
}

export function ProviderLinkValidation({ requiredGameId, nextStep }: Props): JSX.Element {
  const { t } = useTranslation();
  const { user } = useAuth();
  const config = useConfig();

  const [provider, setProvider] = useState<GameProviderConfig>(null);
  const [isProviderLinked, setIsProviderLinked] = useState(false);

  useEffect(() => {
    const gameConfig = config?.serverConfig.gamesConfig.find((x: GameConfig) => x.id === requiredGameId);

    const searchParams = new URLSearchParams(location.search);
    const providerParam = searchParams.get('provider');

    const currentProvider = gameConfig.providers.find((x) => x.name === providerParam) ?? gameConfig.providers[0];
    setProvider(currentProvider);
  }, [requiredGameId]);

  useEffect(() => {
    const isLinked = user?.accounts?.some((account) => account.type === provider?.name);
    setIsProviderLinked(isLinked);
    if (isLinked) {
      nextStep();
    }
  }, [provider, user?.accounts.length]);

  return (
    <>
      <p className='claim-promotion-instructions'>
        {t('promotion.link-provider.description', { requiredGame: t(`translation:games.${requiredGameId}`) })}
      </p>
      {!isProviderLinked && <ProviderComponent name={provider?.name} /> }
    </>
  );
}
